import React, { useState } from 'react';
import './ContactPage.css';

const ContactPage = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    talent: '',
    subject: '',
    message: '',
    experience: '',
    portfolio: ''
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    
    // محاكاة إرسال البيانات
    setTimeout(() => {
      setIsSubmitting(false);
      setSubmitStatus('success');
      setFormData({
        name: '',
        email: '',
        phone: '',
        talent: '',
        subject: '',
        message: '',
        experience: '',
        portfolio: ''
      });
      
      setTimeout(() => setSubmitStatus(null), 5000);
    }, 2000);
  };

  const contactInfo = [
    {
      icon: 'fas fa-map-marker-alt',
      title: 'العنوان',
      details: ['القاهرة، مصر', 'شارع التحرير، وسط البلد']
    },
    {
      icon: 'fas fa-phone',
      title: 'الهاتف',
      details: ['+20 123 456 7890', '+20 987 654 3210']
    },
    {
      icon: 'fas fa-envelope',
      title: 'البريد الإلكتروني',
      details: ['info@basmat-athar.com', 'support@basmat-athar.com']
    },
    {
      icon: 'fas fa-clock',
      title: 'ساعات العمل',
      details: ['الأحد - الخميس: 9:00 ص - 6:00 م', 'الجمعة - السبت: 10:00 ص - 4:00 م']
    }
  ];

  const socialLinks = [
    { icon: 'fab fa-facebook', name: 'Facebook', url: '#' },
    { icon: 'fab fa-instagram', name: 'Instagram', url: '#' },
    { icon: 'fab fa-twitter', name: 'Twitter', url: '#' },
    { icon: 'fab fa-youtube', name: 'YouTube', url: '#' },
    { icon: 'fab fa-linkedin', name: 'LinkedIn', url: '#' },
    { icon: 'fab fa-whatsapp', name: 'WhatsApp', url: '#' }
  ];

  return (
    <div className="contact-page">
      {/* Hero Section */}
      <section className="contact-hero">
        <div className="container">
          <div className="hero-content">
            <h1>تواصل معنا</h1>
            <p>نحن هنا لمساعدتك في رحلتك الإبداعية</p>
          </div>
        </div>
      </section>

      {/* Contact Content */}
      <section className="contact-content">
        <div className="container">
          <div className="contact-grid">
            {/* Contact Form */}
            <div className="contact-form-section">
              <div className="form-header">
                <h2>انضم إلى عائلتنا الإبداعية</h2>
                <p>املأ النموذج أدناه وسنتواصل معك في أقرب وقت</p>
              </div>

              {submitStatus === 'success' && (
                <div className="success-message">
                  <i className="fas fa-check-circle"></i>
                  <p>تم إرسال رسالتك بنجاح! سنتواصل معك قريباً.</p>
                </div>
              )}

              <form className="contact-form" onSubmit={handleSubmit}>
                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="name">الاسم الكامل *</label>
                    <input
                      type="text"
                      id="name"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      required
                      placeholder="أدخل اسمك الكامل"
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="email">البريد الإلكتروني *</label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      required
                      placeholder="example@email.com"
                    />
                  </div>
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="phone">رقم الهاتف</label>
                    <input
                      type="tel"
                      id="phone"
                      name="phone"
                      value={formData.phone}
                      onChange={handleChange}
                      placeholder="+20 123 456 7890"
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="talent">نوع الموهبة *</label>
                    <select
                      id="talent"
                      name="talent"
                      value={formData.talent}
                      onChange={handleChange}
                      required
                    >
                      <option value="">اختر نوع موهبتك</option>
                      <option value="writer">كاتب/ة</option>
                      <option value="poet">شاعر/ة</option>
                      <option value="artist">رسام/ة</option>
                      <option value="digital-artist">فنان رقمي</option>
                      <option value="critic">ناقد أدبي</option>
                      <option value="journalist">صحفي</option>
                      <option value="other">أخرى</option>
                    </select>
                  </div>
                </div>

                <div className="form-group">
                  <label htmlFor="experience">مستوى الخبرة</label>
                  <select
                    id="experience"
                    name="experience"
                    value={formData.experience}
                    onChange={handleChange}
                  >
                    <option value="">اختر مستوى خبرتك</option>
                    <option value="beginner">مبتدئ</option>
                    <option value="intermediate">متوسط</option>
                    <option value="advanced">متقدم</option>
                    <option value="professional">محترف</option>
                  </select>
                </div>

                <div className="form-group">
                  <label htmlFor="subject">موضوع الرسالة *</label>
                  <select
                    id="subject"
                    name="subject"
                    value={formData.subject}
                    onChange={handleChange}
                    required
                  >
                    <option value="">اختر موضوع الرسالة</option>
                    <option value="join">الانضمام للمؤسسة</option>
                    <option value="publish">نشر كتاب</option>
                    <option value="exhibition">تنظيم معرض</option>
                    <option value="interview">طلب حوار صحفي</option>
                    <option value="collaboration">تعاون</option>
                    <option value="support">دعم فني</option>
                    <option value="other">أخرى</option>
                  </select>
                </div>

                <div className="form-group">
                  <label htmlFor="portfolio">رابط أعمالك (اختياري)</label>
                  <input
                    type="url"
                    id="portfolio"
                    name="portfolio"
                    value={formData.portfolio}
                    onChange={handleChange}
                    placeholder="https://example.com/portfolio"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="message">رسالتك *</label>
                  <textarea
                    id="message"
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    required
                    rows="6"
                    placeholder="اكتب رسالتك هنا... حدثنا عن موهبتك وأهدافك"
                  ></textarea>
                </div>

                <button 
                  type="submit" 
                  className="submit-btn"
                  disabled={isSubmitting}
                >
                  {isSubmitting ? (
                    <>
                      <i className="fas fa-spinner fa-spin"></i>
                      جاري الإرسال...
                    </>
                  ) : (
                    <>
                      <i className="fas fa-paper-plane"></i>
                      إرسال الرسالة
                    </>
                  )}
                </button>
              </form>
            </div>

            {/* Contact Info */}
            <div className="contact-info-section">
              <div className="contact-info">
                <h3>معلومات التواصل</h3>
                <p>نحن متاحون دائماً للإجابة على استفساراتكم ومساعدتكم</p>

                <div className="contact-details">
                  {contactInfo.map((info, index) => (
                    <div key={index} className="contact-item">
                      <div className="contact-icon">
                        <i className={info.icon}></i>
                      </div>
                      <div className="contact-text">
                        <h4>{info.title}</h4>
                        {info.details.map((detail, idx) => (
                          <p key={idx}>{detail}</p>
                        ))}
                      </div>
                    </div>
                  ))}
                </div>

                <div className="social-section">
                  <h4>تابعنا على</h4>
                  <div className="social-links">
                    {socialLinks.map((social, index) => (
                      <a 
                        key={index} 
                        href={social.url} 
                        className="social-link"
                        aria-label={social.name}
                      >
                        <i className={social.icon}></i>
                      </a>
                    ))}
                  </div>
                </div>
              </div>

              {/* FAQ Section */}
              <div className="faq-section">
                <h3>أسئلة شائعة</h3>
                <div className="faq-list">
                  <div className="faq-item">
                    <h4>كيف يمكنني الانضمام للمؤسسة؟</h4>
                    <p>املأ نموذج التواصل أو راسلنا مباشرة وسنتواصل معك لمناقشة التفاصيل.</p>
                  </div>
                  <div className="faq-item">
                    <h4>هل هناك رسوم للانضمام؟</h4>
                    <p>لا، الانضمام مجاني. نحن نؤمن بدعم المواهب دون عوائق مالية.</p>
                  </div>
                  <div className="faq-item">
                    <h4>كم يستغرق نشر الكتاب؟</h4>
                    <p>عادة ما يستغرق من 4-8 أسابيع حسب نوع الكتاب ومتطلبات التحرير.</p>
                  </div>
                  <div className="faq-item">
                    <h4>هل تقدمون دعماً للفنانين المبتدئين؟</h4>
                    <p>نعم، نرحب بجميع المستويات ونقدم برامج تدريبية للمبتدئين.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Map Section */}
      <section className="map-section">
        <div className="container">
          <h3>موقعنا</h3>
          <div className="map-placeholder">
            <div className="map-content">
              <i className="fas fa-map-marked-alt"></i>
              <p>خريطة تفاعلية لموقع المؤسسة</p>
              <p>القاهرة، مصر - شارع التحرير، وسط البلد</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ContactPage;
